import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppState } from '../../../reducers';

@Component({
  standalone: false,
  selector: 'dsp-email-sent',
  templateUrl: 'email-sent.component.html'
})
export class EmailSentComponent implements OnInit {
  public form: FormGroup;
  public email = 'noreply@mercer.com';

  public constructor(
    private readonly store: Store<AppState>
  ) {}

  public ngOnInit(): void {
    this.form = new FormGroup({
      security: new FormControl('', [ Validators.required ])
    });
  }

  public onConfirm(): void {}

  public onActivate(): void {}
}
